


// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, addProperty, incrementPropertyCount } from '../Commonlibs/userSlice';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   Button,
//   Card,
//   CardContent,
//   Container,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   InputAdornment,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Check as CheckIcon,
//   Phone,
//   Email,
//   Person,
// } from "@mui/icons-material";
// import checkmarkIcon from '../assets/greencir.png';
// import Loader from '../Loader/Loader';

// const RentDetails = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();

//   // State variables for form data
//   const [monthlyRent, setMonthlyRent] = useState(() => localStorage.getItem('rent_monthlyRent') || '');
//   const [monthlyRentError, setMonthlyRentError] = useState('');
//   const [currency, setCurrency] = useState(() => localStorage.getItem('rent_currency') || '₹');
//   const [availableFrom, setAvailableFrom] = useState(() => localStorage.getItem('rent_availableFrom') || '');
//   const [availableFromError, setAvailableFromError] = useState('');
//   const [securityDeposit, setSecurityDeposit] = useState(() => localStorage.getItem('rent_securityDeposit') || 'none');
//   const [constructionStatus, setConstructionStatus] = useState('ready to move');

//   // State for loading and alerts
//   const [loading, setLoading] = useState(false);
//   const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

//   // ✅ Profile verification states (NO OTP)
//   const [profileData, setProfileData] = useState(null);
//   const [loadingProfile, setLoadingProfile] = useState(true);
//   const [showVerificationDialog, setShowVerificationDialog] = useState(false);
//   const [verificationForm, setVerificationForm] = useState({
//     fullName: '',
//     email: '',
//     contactNumber: '',
//   });
//   const [verificationErrors, setVerificationErrors] = useState({});
//   const [verificationLoading, setVerificationLoading] = useState(false);

//   // Get data from previous screens
//   const { propertyType, category, ...otherProps } = location.state || {};

//   // ✅ NEW: Clear all form data function
//   const clearAllRentFormData = () => {
//     // Clear RentDetails form data
//     setMonthlyRent('');
//     setCurrency('₹');
//     setAvailableFrom('');
//     setSecurityDeposit('none');
//     setConstructionStatus('ready to move');
    
//     // Clear all localStorage items
//     localStorage.removeItem('rent_monthlyRent');
//     localStorage.removeItem('rent_currency');
//     localStorage.removeItem('rent_availableFrom');
//     localStorage.removeItem('rent_securityDeposit');
//     localStorage.removeItem('propertyDetailsFormState');
//     localStorage.removeItem('propertyType');
//     localStorage.removeItem('category');
//     localStorage.removeItem('propertyLocation');
    
//     // Clear errors
//     setMonthlyRentError('');
//     setAvailableFromError('');
//   };

//   // ✅ Fetch user profile data on mount
//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       const userId = user?.id;
//       if (!userId) {
//         setLoadingProfile(false);
//         return;
//       }

//       try {
//         setLoadingProfile(true);
//         const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
//         const data = await response.json();

//         if (data.status === "SUCCESS") {
//           setProfileData(data.result);
//         }
//       } catch (err) {
//         console.error('Error fetching profile:', err);
//       } finally {
//         setLoadingProfile(false);
//       }
//     };

//     fetchUserProfile();
//   }, [user?.id]);

//   const handleBack = () => {
//   // ✅ Pass back ALL state including asset_type
//   navigate('/property-details', { 
//     state: { 
//       propertyType: propertyType || location.state?.propertyType,
//       category: category || location.state?.category,
//       location: location.state?.location || '',
//       // ✅ CRITICAL: Include asset_type and selectedType
//       asset_type: location.state?.asset_type || '',
//       selectedType: location.state?.selectedType || '',
//       // ✅ Pass all other state back
//       ...location.state
//     } 
//   });
// };

//   // Security deposit options
//   const depositOptions = [
//     { label: "None", value: "none" },
//     { label: "1 month", value: "1month" },
//     { label: "2 month", value: "2month" },
//     { label: "Custom", value: "custom" },
//   ];

//   // Helper function to format number with Indian comma system
//   const formatIndianNumber = (num) => {
//     if (!num) return '';
//     const numStr = num.toString();
//     const lastThree = numStr.substring(numStr.length - 3);
//     const otherNumbers = numStr.substring(0, numStr.length - 3);
//     if (otherNumbers !== '') {
//       return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
//     }
//     return lastThree;
//   };

//   // Helper function to convert number to words (Indian system)
//   const convertToWords = (num) => {
//     if (!num || num === '0') return '';

//     const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
//     const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
//     const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

//     const numToWords = (n) => {
//       if (n < 10) return ones[n];
//       if (n < 20) return teens[n - 10];
//       if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
//       return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + numToWords(n % 100) : '');
//     };

//     const crore = Math.floor(num / 10000000);
//     const lakh = Math.floor((num % 10000000) / 100000);
//     const thousand = Math.floor((num % 100000) / 1000);
//     const hundred = num % 1000;

//     let result = '';
//     if (crore > 0) result += numToWords(crore) + ' Crore ';
//     if (lakh > 0) result += numToWords(lakh) + ' Lakh ';
//     if (thousand > 0) result += numToWords(thousand) + ' Thousand ';
//     if (hundred > 0) result += numToWords(hundred);

//     return result.trim();
//   };

//   // Validate monthly rent
//   const validateMonthlyRent = (value) => {
//     if (!value || value.trim() === '') {
//       setMonthlyRentError('Monthly rent is required');
//       return false;
//     }

//     const amountRegex = /^\d+(\.\d{0,2})?$/;
//     if (!amountRegex.test(value)) {
//       setMonthlyRentError('Please enter a valid amount (e.g., 5000 or 5000.50)');
//       return false;
//     }

//     const amount = parseFloat(value);
//     if (amount < 100) {
//       setMonthlyRentError('Monthly rent must be at least 100');
//       return false;
//     }

//     if (amount > 100000000) {
//       setMonthlyRentError('Monthly rent cannot exceed 10 crores');
//       return false;
//     }

//     setMonthlyRentError('');
//     return true;
//   };

//   // Validate available from date
//   const validateAvailableFrom = (value) => {
//     if (!value || value.trim() === '') {
//       setAvailableFromError('Available from date is required');
//       return false;
//     }

//     const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
//     if (!dateRegex.test(value)) {
//       setAvailableFromError('Invalid date format');
//       return false;
//     }

//     const selectedDate = new Date(value);
//     if (isNaN(selectedDate.getTime())) {
//       setAvailableFromError('Invalid date');
//       return false;
//     }

//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     if (selectedDate < today) {
//       setAvailableFromError('Date must be today or in the future');
//       return false;
//     }

//     const twoYearsFromNow = new Date();
//     twoYearsFromNow.setFullYear(today.getFullYear() + 2);

//     if (selectedDate > twoYearsFromNow) {
//       setAvailableFromError('Date cannot be more than 2 years in the future');
//       return false;
//     }

//     setAvailableFromError('');
//     return true;
//   };

//   // Handle monthly rent change
//   const handleMonthlyRentChange = (e) => {
//     const value = e.target.value;
//     if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
//       setMonthlyRent(value);
//       validateMonthlyRent(value);
//     }
//   };

//   // Handle available from change
//   const handleAvailableFromChange = (e) => {
//     const value = e.target.value;
//     setAvailableFrom(value);
//     validateAvailableFrom(value);
//   };

//   // ✅ Validation functions for verification form
//   const validateVerificationField = (name, value) => {
//     if (!value || value.trim() === '' || value === 'N/A') {
//       return `${name} is required`;
//     }

//     switch (name) {
//       case 'fullName':
//         return /^[A-Za-z\s]{2,50}$/.test(value)
//           ? ''
//           : 'Name should contain only letters and spaces (2-50 characters)';
//       case 'email':
//         return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
//           ? ''
//           : 'Please enter a valid email address';
//       case 'contactNumber':
//         return /^\d{10}$/.test(value)
//           ? ''
//           : 'Phone number should be 10 digits';
//       default:
//         return '';
//     }
//   };

//   // ✅ Handle verification form changes
//   const handleVerificationChange = (field, value) => {
//     setVerificationForm(prev => ({ ...prev, [field]: value }));
//     if (verificationErrors[field]) {
//       setVerificationErrors(prev => ({ ...prev, [field]: '' }));
//     }
//   };

//   // ✅ Handle phone number input (only digits)
//   const handlePhoneNumberChange = (e) => {
//     const value = e.target.value;
//     if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
//       handleVerificationChange('contactNumber', value);
//     }
//   };

//   // ✅ Update user profile (NO OTP - Direct Update)
//   const updateUserProfile = async () => {
//     setVerificationLoading(true);
//     try {
//       const formDataToSend = new FormData();
//       formDataToSend.append('user_id', user?.id);
//       formDataToSend.append('full_name', verificationForm.fullName);
//       formDataToSend.append('email_id', verificationForm.email);
//       formDataToSend.append('contact_number', verificationForm.contactNumber);

//       const response = await fetch('https://propertydealstalk.com/api/users/UpdateUserprofile', {
//         method: 'POST',
//         body: formDataToSend,
//       });

//       const data = await response.json();

//       if (data.status === "SUCCESS") {
//         setProfileData(data.result);
//         setShowVerificationDialog(false);

//         // Proceed with property upload
//         setTimeout(() => {
//           performPropertyUpload();
//         }, 500);
//       } else {
//         setAlert({
//           open: true,
//           message: data.message || 'Failed to update profile',
//           severity: 'error'
//         });
//       }
//     } catch (error) {
//       console.error('Profile update error:', error);
//       setAlert({
//         open: true,
//         message: 'Failed to update profile. Please try again.',
//         severity: 'error'
//       });
//     } finally {
//       setVerificationLoading(false);
//     }
//   };

//   // ✅ Handle verification submit (Direct - No OTP)
//   const handleVerificationSubmit = async () => {
//     // Validate all fields
//     const newErrors = {};
//     Object.keys(verificationForm).forEach(key => {
//       const error = validateVerificationField(key, verificationForm[key]);
//       if (error) newErrors[key] = error;
//     });

//     if (Object.keys(newErrors).length > 0) {
//       setVerificationErrors(newErrors);
//       return;
//     }

//     // Direct profile update without OTP
//     await updateUserProfile();
//   };

//   // ✅ Handle property upload - check profile first
//   const handleUploadProperty = async () => {
//     // Validate all fields before submission
//     const isRentValid = validateMonthlyRent(monthlyRent);
//     const isDateValid = validateAvailableFrom(availableFrom);

//     if (!isRentValid || !isDateValid) {
//       setAlert({
//         open: true,
//         message: 'Please fix the errors before submitting',
//         severity: 'error'
//       });
//       return;
//     }

//     // ✅ Check if user profile needs verification
//     const needsVerification =
//       !profileData?.full_name ||
//       profileData.full_name === 'N/A' ||
//       !profileData?.email_id ||
//       profileData.email_id === 'N/A' ||
//       !profileData?.contact_number ||
//       profileData.contact_number === 'N/A';

//     if (needsVerification) {
//       // Initialize verification form with available data
//       setVerificationForm({
//         fullName: profileData?.full_name && profileData.full_name !== 'N/A' ? profileData.full_name : '',
//         email: profileData?.email_id && profileData.email_id !== 'N/A' ? profileData.email_id : '',
//         contactNumber: profileData?.contact_number && profileData.contact_number !== 'N/A' ? profileData.contact_number : '',
//       });
//       setShowVerificationDialog(true);
//       return;
//     }

//     // Profile is complete, proceed with upload
//     await performPropertyUpload();
//   };

//   // ✅ Actual property upload logic
//   const performPropertyUpload = async () => {
//     setLoading(true);
//     try {
//       // Validate required fields
//       if (!monthlyRent || !availableFrom || !securityDeposit) {
//         setAlert({
//           open: true,
//           message: 'Please fill all required fields',
//           severity: 'error'
//         });
//         setLoading(false);
//         return;
//       }

//       // Get user ID from Redux store
//       const userId = user?.id;
//       if (!userId) {
//         throw new Error('User not authenticated');
//       }

//       // Determine property type details
//       const assetType = location.state?.asset_type || '';
//       const selectedType = location.state?.selectedType || '';

//       // Enhanced detection for Plot and Agriculture Land property types
//       const isplot = assetType === 'plot' || selectedType === 'plot';
//       const isAgricultureLand = assetType.toLowerCase() === 'agriculture land' || selectedType === 'agriculture-land';
//       const isCommercial = propertyType === 'Commercial';

//       // Create a FormData object for the API call
//       const formData = new FormData();

//       // Add basic fields
//       formData.append('seller_id', userId);
//       formData.append('property_type', isCommercial ? 'commercial' : 'residential');
//       formData.append('category', 'rent');
//       formData.append('location', location.state?.location || '');
//       formData.append('asset_type', assetType);
//       formData.append('property_name', location.state?.buildingName || '');
//       formData.append('area_name', location.state?.areaName || '');
//       formData.append('full_address', location.state?.completeAddress || location.state?.full_address || '');

//       const showAreaFields = assetType.toLowerCase() === 'apartment' || selectedType === 'apartment' ||
//         assetType.toLowerCase() === 'independent house' || selectedType === 'independent-house' ||
//         assetType.toLowerCase() === 'duplex' || selectedType === 'duplex';

//       formData.append('carpet_area', showAreaFields ? (location.state?.carpet_area || '') : '');
//       formData.append('carpet_area_units', showAreaFields ? (location.state?.carpet_area_units || '') : '');
//       formData.append('built_up_area', showAreaFields ? (location.state?.built_up_area || '') : '');
//       formData.append('built_up_area_units', showAreaFields ? (location.state?.built_up_area_units || '') : '');
//      formData.append('uds', showAreaFields ? (location.state?.uds_area || '') : '');
// formData.append('uds_units', showAreaFields ? (location.state?.uds_area_units || 'Sq.Ft') : '');

//       const youtubeLink = location.state?.youtubeLink?.trim();
//       formData.append('youtube_link', youtubeLink || null);

//       formData.append('property_size', location.state?.propertySize || '');
//       formData.append('property_size_units', location.state?.property_size_units || location.state?.selectedUnit || '');
//       formData.append('length', location.state?.length || location.state?.propertyLength || '');
//       formData.append('width', location.state?.width || location.state?.propertyWidth || '');

//       formData.append('construction_status', constructionStatus || 'ready to move');

//       // Price fields for rent
//       formData.append('monthly_rent', Number(monthlyRent) || 0);
//       formData.append('available_from', availableFrom);
//       formData.append('security_deposit', securityDeposit);
//       formData.append('currency', currency);

//       // Set sale-specific fields to null
//       formData.append('asking_price', null);
//       formData.append('negotiable', null);

//       formData.append('age_of_property', location.state?.age_of_property || '5');

//       // SPECIAL HANDLING FOR PLOT AND AGRICULTURE LAND
//       if (isplot || isAgricultureLand) {
//         formData.append('locality', null);
//         formData.append('bhk', null);
//         formData.append('furnish_type', null);
//         formData.append('total_floors', null);
//         formData.append('select_floor', null);
//         formData.append('society_aminities', null);
//         formData.append('furnish_facilities', null);
//         formData.append('other_facilities', null);
//         formData.append('facilities_distance', null);

//         if (isplot) {
//           const description = location.state?.propertyDescription || location.state?.description || '';
//           const content = location.state?.propertyContent || location.state?.content || '';
//           formData.append('description', description || null);
//           formData.append('content', content || null);
//         } else {
//           formData.append('description', null);
//           formData.append('content', null);
//         }

//         if (isCommercial) {
//           formData.append('commercial_catgory', 'rent');
//           formData.append('commercial_asset_type', assetType);
//           formData.append('hub', null);
//           formData.append('ownership', null);
//         } else {
//           formData.append('commercial_catgory', null);
//           formData.append('commercial_asset_type', null);
//           formData.append('hub', null);
//           formData.append('ownership', null);
//         }
//       } else {
//         // REGULAR PROPERTIES (Apartment, House, Office, etc.)
//         formData.append('locality', location.state?.locality || null);

//         if (!isCommercial) {
//           formData.append('bhk', location.state?.bhk || location.state?.selectedBHK || '');
//           formData.append('furnish_type', location.state?.furnish_type || location.state?.selectedFurnish || '');
//         } else {
//           formData.append('bhk', null);
//           formData.append('furnish_type', null);
//         }

//         formData.append('total_floors', location.state?.totalFloors || location.state?.total_floors || '');
//         formData.append('select_floor', location.state?.selectedFloor || location.state?.select_floor || '');

//         if (!isCommercial && location.state) {
//           const societyAmenities = location.state.society_aminities || '';
//           const furnishFacilities = location.state.furnish_facilities || '';
//           const otherFacilities = location.state.other_facilities || '';

//           formData.append('society_aminities', societyAmenities || null);
//           formData.append('furnish_facilities', furnishFacilities || null);
//           formData.append('other_facilities', otherFacilities || null);
//           formData.append('facilities_distance', location.state?.facilities_distance || '1km');
//         } else {
//           formData.append('society_aminities', null);
//           formData.append('furnish_facilities', null);
//           formData.append('other_facilities', null);
//           formData.append('facilities_distance', null);
//         }

//         if (isCommercial) {
//           formData.append('commercial_catgory', 'rent');
//           formData.append('commercial_asset_type', assetType);
//           formData.append('hub', location.state?.hub || location.state?.selectedHub || '');
//           formData.append('ownership', location.state?.ownership || location.state?.selectedOwnership || 'Freehold');
//         } else {
//           formData.append('commercial_catgory', null);
//           formData.append('commercial_asset_type', null);
//           formData.append('hub', null);
//           formData.append('ownership', null);
//         }
//       }

//       // Add images to the FormData
//       if (location.state?.propertyImages && location.state.propertyImages.length > 0) {
//         location.state.propertyImages.forEach((file) => {
//           formData.append('property_images', file);
//         });
//       }

//       // Add videos to the FormData
//       if (location.state?.propertyVideos && location.state.propertyVideos.length > 0) {
//         location.state.propertyVideos.forEach((file) => {
//           formData.append('property_videos', file);
//         });
//       }

//       // API call with FormData
//       const response = await fetch('https://propertydealstalk.com/api/property/addProperty', {
//         method: 'POST',
//         body: formData
//       });

//       const data = await response.json();

//       if (data.status === 'SUCCESS') {
//         // ✅ CLEAR ALL FORM DATA - SUCCESS CASE
//         clearAllRentFormData();

//         // Store property ID in Redux if available
//         if (data.result && data.result.id) {
//           dispatch(addProperty(data.result.id));
//           dispatch(incrementPropertyCount());
//         }

//         setAlert({
//           open: true,
//           message: 'Property added successfully!',
//           severity: 'success'
//         });

//         setTimeout(() => {
//           navigate('/sell-properties');
//         }, 2000);
//       } else {
//         throw new Error(data.message || 'Failed to add property');
//       }
//     } catch (error) {
//       console.error('Error adding property:', error);

//       // ✅ CLEAR ALL FORM DATA - ERROR CASE ALSO
//       clearAllRentFormData();

//       setAlert({
//         open: true,
//         message: error.message || 'Failed to add property. Please try again.',
//         severity: 'error'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Persist form values to localStorage
//   useEffect(() => {
//     localStorage.setItem('rent_monthlyRent', monthlyRent);
//     localStorage.setItem('rent_currency', currency);
//     localStorage.setItem('rent_availableFrom', availableFrom);
//     localStorage.setItem('rent_securityDeposit', securityDeposit);
//   }, [monthlyRent, currency, availableFrom, securityDeposit]);

//   // Auto-hide popup after a delay
//   useEffect(() => {
//     if (alert.open) {
//       const timer = setTimeout(() => {
//         setAlert({ ...alert, open: false });
//       }, 9000);
//       return () => clearTimeout(timer);
//     }
//   }, [alert.open]);

//   return (
//     <Container maxWidth="lg" sx={{ mt: '32px', mb: '120px' }}>
//       {loading && <Loader />}

//       <Card sx={{ borderRadius: "30px", border: "2px solid #d0d0d0" }}>
//         <CardContent sx={{ p: { xs: 3, md: 6 } }}>
//           {/* Custom Stepper */}
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 4 }}>
//             <Box sx={{
//               display: 'flex',
//               alignItems: 'center',
//               flexDirection: { xs: 'column', sm: 'row' },
//               gap: { xs: 2, sm: 0 }
//             }}>
//               {/* Step 1 - Completed */}
//               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                 <Typography sx={{
//                   mb: 1,
//                   fontSize: '16px',
//                   fontWeight: 'normal',
//                   color: 'black',
//                   fontFamily: 'Outfit'
//                 }}>
//                   Basic Details
//                 </Typography>
//                 <Box sx={{
//                   width: 35,
//                   height: 35,
//                   borderRadius: '18px',
//                   border: '3px solid #1a507d',
//                   backgroundColor: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}>
//                   <Box
//                     component="img"
//                     src={checkmarkIcon}
//                     alt="Step Icon"
//                     sx={{
//                       width: 22,
//                       height: 22,
//                       objectFit: 'contain'
//                     }}
//                   />
//                 </Box>
//               </Box>

//               {/* Divider - Hide on mobile */}
//               <Box sx={{
//                 width: '100px',
//                 height: '1px',
//                 backgroundColor: '#d0d0d0',
//                 mx: 2,
//                 display: { xs: 'none', sm: 'block' }
//               }} />

//               {/* Step 2 - Completed */}
//               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                 <Typography sx={{
//                   mb: 1,
//                   fontSize: '16px',
//                   fontWeight: 'normal',
//                   color: 'black',
//                   fontFamily: 'Outfit'
//                 }}>
//                   Property Details
//                 </Typography>
//                 <Box sx={{
//                   width: 35,
//                   height: 35,
//                   borderRadius: '18px',
//                   border: '3px solid #1a507d',
//                   backgroundColor: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}>
//                   <Box
//                     component="img"
//                     src={checkmarkIcon}
//                     alt="Step Icon"
//                     sx={{
//                       width: 22,
//                       height: 22,
//                       objectFit: 'contain'
//                     }}
//                   />
//                 </Box>
//               </Box>

//               {/* Divider - Hide on mobile */}
//               <Box sx={{
//                 width: '100px',
//                 height: '1px',
//                 backgroundColor: '#d0d0d0',
//                 mx: 2,
//                 display: { xs: 'none', sm: 'block' }
//               }} />

//               {/* Step 3 - Active */}
//               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                 <Typography sx={{
//                   mb: 1,
//                   fontSize: '16px',
//                   fontWeight: 'normal',
//                   color: 'black',
//                   fontFamily: 'Outfit'
//                 }}>
//                   Price Details
//                 </Typography>
//                 <Box sx={{
//                   width: 35,
//                   height: 35,
//                   borderRadius: '18px',
//                   border: '3px solid #1a507d',
//                   backgroundColor: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}>
//                   <Box sx={{
//                     width: 22,
//                     height: 22,
//                     backgroundColor: '#1c274c',
//                     borderRadius: '11px'
//                   }} />
//                 </Box>
//               </Box>
//             </Box>
//           </Box>

//           {/* Form Content */}
//           <Box sx={{ mt: 4 }}>
//             <Typography
//               sx={{
//                 fontFamily: "Outfit, sans-serif",
//                 fontWeight: 500,
//                 color: "text.primary",
//                 fontSize: "20px",
//                 mb: 5,
//               }}
//             >
//               Add Price Details
//             </Typography>

//                         {/* Monthly Rent */}
//             <Box sx={{ mb: 5 }}>
//               <Typography
//                 component="label"
//                 sx={{
//                   fontFamily: "Outfit, sans-serif",
//                   fontWeight: 500,
//                   color: "text.secondary",
//                   fontSize: "18px",
//                   display: "block",
//                   mb: 1.5,
//                 }}
//               >
//                 Monthly Rent <Box component="span" sx={{ color: "#ff0000" }}>*</Box>
//               </Typography>
//               <Box sx={{ position: "relative", width: { xs: "100%", sm: "340px" } }}>
//                 <TextField
//                   placeholder="Enter amount"
//                   value={formatIndianNumber(monthlyRent)}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/,/g, '');
//                     if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
//                       setMonthlyRent(value);
//                       validateMonthlyRent(value);
//                     }
//                   }}
//                   error={!!monthlyRentError}
//                   helperText={monthlyRentError}
//                   sx={{
//                     width: "100%",
//                     "& .MuiInputBase-root": {
//                       height: "55px",
//                       bgcolor: "background.paper",
//                       borderRadius: "10px",
//                       fontFamily: "Outfit, sans-serif",
//                       fontSize: "20px",
//                       paddingRight: "40px",
//                     },
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     right: "12px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#626262",
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "20px",
//                     pointerEvents: "none",
//                     zIndex: 1,
//                   }}
//                 >
//                   ₹
//                 </Box>
//               </Box>
//               {/* Display price in words */}
//               {monthlyRent && !monthlyRentError && (
//                 <Typography
//                   sx={{
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "14px",
//                     color: "#4f26ff",
//                     mt: 1,
//                     fontStyle: "italic",
//                   }}
//                 >
//                   {convertToWords(parseInt(monthlyRent.split('.')[0], 10))}
//                 </Typography>
//               )}
//             </Box>

//             {/* Available from */}
// <Box sx={{ mb: 5 }}>
//   <Typography
//     component="label"
//     sx={{
//       fontFamily: "Outfit, sans-serif",
//       fontWeight: 500,
//       color: "text.secondary",
//       fontSize: "18px",
//       display: "block",
//       mb: 1.5,
//     }}
//   >
//     Available from <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
//   </Typography>
//   <Box sx={{ position: "relative", width: { xs: "100%", sm: "350px" } }}>
//     <TextField
//       placeholder="Select Date"
//       type="date"
//       value={availableFrom}
//       onChange={handleAvailableFromChange}
//       error={!!availableFromError}
//       helperText={availableFromError || "Date must be today or in the future"}
//       inputProps={{
//         min: new Date().toISOString().split('T')[0], // This disables all previous dates
//       }}
//       sx={{
//         width: "100%",
//         "& .MuiInputBase-root": {
//           height: "55px",
//           borderRadius: "10px",
//           fontSize: "20px",
//           fontFamily: "Outfit, sans-serif"
//         }
//       }}
//     />
//   </Box>
// </Box>

//             {/* Security Deposit */}
//             <Box sx={{ mb: 85 }}>
//               <Typography
//                 component="label"
//                 sx={{
//                   fontFamily: "Outfit, sans-serif",
//                   fontWeight: 500,
//                   color: "text.secondary",
//                   fontSize: "18px",
//                   display: "block",
//                   mb: 1.5,
//                 }}
//               >
//                 Security Deposit <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
//               </Typography>
//               <Box sx={{
//                 display: "flex",
//                 gap: 2,
//                 flexWrap: { xs: "wrap", md: "nowrap" }
//               }}>
//                 {depositOptions.map((option, index) => (
//                   <Button
//                     key={index}
//                     variant="outlined"
//                     onClick={() => setSecurityDeposit(option.value)}
//                     sx={{
//                       width: { xs: "calc(50% - 8px)", sm: "140px" },
//                       height: "55px",
//                       bgcolor: securityDeposit === option.value ? "#eeeaff" : "white",
//                       borderRadius: "10px",
//                       border: "1px solid rgba(0, 0, 0, 0.23)",
//                       fontFamily: "Outfit, sans-serif",
//                       fontWeight: securityDeposit === option.value ? 500 : 400,
//                       color: securityDeposit === option.value ? "#4f26ff" : "#626262",
//                       fontSize: "18px",
//                       textTransform: "none",
//                     }}
//                   >
//                     {option.label}
//                   </Button>
//                 ))}
//               </Box>
//             </Box>
//           </Box>

//           {/* Action Buttons */}
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               mt: { xs: 10, md: 20 },
//               flexDirection: { xs: "column", sm: "row" },
//               gap: { xs: 2, sm: 0 },
//             }}
//           >
//             <Button
//               variant="outlined"
//               onClick={handleBack}
//               sx={{
//                 width: { xs: "100%", sm: "100px" },
//                 height: "50px",
//                 bgcolor: "#c2c2c2",
//                 borderRadius: "10px",
//                 border: "1px solid rgba(0, 0, 0, 0.23)",
//                 fontFamily: "Outfit, sans-serif",
//                 fontWeight: 400,
//                 color: "#020202",
//                 fontSize: "22px",
//                 textTransform: "none",
//               }}
//             >
//               Back
//             </Button>
//             <Button
//               onClick={handleUploadProperty}
//               disabled={loading || !!monthlyRentError || !!availableFromError}
//               sx={{
//                 width: { xs: "100%", sm: "211px" },
//                 height: "50px",
//                 bgcolor: "primary.main",
//                 borderRadius: "10px",
//                 border: "1px solid rgba(0, 0, 0, 0.23)",
//                 fontFamily: "Outfit, sans-serif",
//                 fontWeight: 400,
//                 color: "white",
//                 fontSize: "22px",
//                 textTransform: "none",
//                 '&:disabled': {
//                   bgcolor: '#b0b0b0',
//                   color: '#f5f5f5'
//                 }
//               }}
//             >
//               {loading ? "Uploading..." : "Post Property"}
//             </Button>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* ✅ Profile Verification Dialog (NO OTP) */}
//       <Dialog
//         open={showVerificationDialog}
//         onClose={() => !verificationLoading && setShowVerificationDialog(false)}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: '16px',
//             p: 2,
//           }
//         }}
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           fontSize: '24px',
//           pb: 1
//         }}>
//           Verify Your Details
//         </DialogTitle>
//         <DialogContent>
//           <Typography sx={{
//             fontFamily: 'Outfit',
//             fontSize: '14px',
//             color: '#666',
//             mb: 3
//           }}>
//             Please verify your contact information before posting the property
//           </Typography>

//           {/* Full Name */}
//           <Box sx={{ mb: 2 }}>
//             <Typography sx={{
//               fontFamily: 'Outfit',
//               fontSize: '14px',
//               fontWeight: 500,
//               mb: 1
//             }}>
//               Full Name <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <TextField
//               fullWidth
//               placeholder="Enter your full name"
//               value={verificationForm.fullName}
//               onChange={(e) => handleVerificationChange('fullName', e.target.value)}
//               error={!!verificationErrors.fullName}
//               helperText={verificationErrors.fullName}
//               disabled={verificationLoading}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Person sx={{ color: '#666' }} />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{
//                 '& .MuiInputBase-root': {
//                   borderRadius: '8px',
//                   fontFamily: 'Outfit',
//                 }
//               }}
//             />
//           </Box>

//           {/* Email */}
//           <Box sx={{ mb: 2 }}>
//             <Typography sx={{
//               fontFamily: 'Outfit',
//               fontSize: '14px',
//               fontWeight: 500,
//               mb: 1
//             }}>
//               Email Address <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <TextField
//               fullWidth
//               type="email"
//               placeholder="Enter your email"
//               value={verificationForm.email}
//               onChange={(e) => handleVerificationChange('email', e.target.value)}
//               error={!!verificationErrors.email}
//               helperText={verificationErrors.email}
//               disabled={verificationLoading}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Email sx={{ color: '#666' }} />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{
//                 '& .MuiInputBase-root': {
//                   borderRadius: '8px',
//                   fontFamily: 'Outfit',
//                 }
//               }}
//             />
//           </Box>

//           {/* Mobile Number */}
//           <Box sx={{ mb: 2 }}>
//             <Typography sx={{
//               fontFamily: 'Outfit',
//               fontSize: '14px',
//               fontWeight: 500,
//               mb: 1
//             }}>
//               Mobile Number <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <TextField
//               fullWidth
//               placeholder="Enter 10-digit mobile number"
//               value={verificationForm.contactNumber}
//               onChange={handlePhoneNumberChange}
//               error={!!verificationErrors.contactNumber}
//               helperText={verificationErrors.contactNumber}
//               disabled={verificationLoading}
//               inputProps={{ maxLength: 10 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Phone sx={{ color: '#666' }} />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{
//                 '& .MuiInputBase-root': {
//                   borderRadius: '8px',
//                   fontFamily: 'Outfit',
//                 }
//               }}
//             />
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 3 }}>
//           <Button
//             onClick={() => {
//               if (!verificationLoading) {
//                 setShowVerificationDialog(false);
//                 setVerificationErrors({});
//               }
//             }}
//             disabled={verificationLoading}
//             sx={{
//               textTransform: 'none',
//               fontFamily: 'Outfit',
//               color: '#666',
//               borderRadius: '8px',
//               px: 3,
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleVerificationSubmit}
//             disabled={verificationLoading}
//             variant="contained"
//             sx={{
//               textTransform: 'none',
//               fontFamily: 'Outfit',
//               bgcolor: '#4f26ff',
//               borderRadius: '8px',
//               px: 3,
//               '&:hover': {
//                 bgcolor: '#3d1fd9',
//               },
//             }}
//           >
//             {verificationLoading ? (
//               <CircularProgress size={24} sx={{ color: 'white' }} />
//             ) : (
//               'Confirm'
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Alert Dialog */}
//       <Dialog
//         open={alert.open}
//         onClose={() => setAlert({ ...alert, open: false })}
//         PaperProps={{
//           sx: {
//             borderRadius: "12px",
//             boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
//             maxWidth: "400px",
//             width: "100%",
//             margin: '0 16px',
//             overflow: 'hidden'
//           }
//         }}
//       >
//         <DialogContent sx={{
//           padding: "24px",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           backgroundColor: "#ffffff",
//           minHeight: "180px",
//         }}>
//           {/* Icon based on alert severity */}
//           <Box sx={{ mb: 2 }}>
//             {alert.severity === 'success' && (
//               <CheckIcon sx={{
//                 fontSize: 48,
//                 color: '#2e7d32',
//                 p: 1,
//                 borderRadius: '50%',
//                 backgroundColor: 'rgba(46, 125, 50, 0.1)'
//               }} />
//             )}
//             {alert.severity === 'error' && (
//               <Box component="span" sx={{
//                 fontSize: 48,
//                 color: '#d32f2f',
//                 p: 1,
//                 borderRadius: '50%',
//                 backgroundColor: 'rgba(211, 47, 47, 0.1)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}>
//                 ✕
//               </Box>
//             )}
//             {alert.severity === 'warning' && (
//               <Box component="span" sx={{
//                 fontSize: 48,
//                 color: '#ed6c02',
//                 p: 1,
//                 borderRadius: '50%',
//                 backgroundColor: 'rgba(237, 108, 2, 0.1)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}>
//                 !
//               </Box>
//             )}
//             {alert.severity === 'info' && (
//               <Box component="span" sx={{
//                 fontSize: 48,
//                 color: '#0288d1',
//                 p: 1,
//                 borderRadius: '50%',
//                 backgroundColor: 'rgba(2, 136, 209, 0.1)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}>
//                 i
//               </Box>
//             )}
//           </Box>
//           <DialogContentText sx={{
//             fontFamily: "Outfit, sans-serif",
//             fontSize: "18px",
//             textAlign: "center",
//             color: alert.severity === 'error' ? '#d32f2f' :
//               alert.severity === 'warning' ? '#ed6c02' :
//                 alert.severity === 'success' ? '#2e7d32' : '#0288d1',
//             margin: 0,
//             fontWeight: 500
//           }}>
//             {alert.message}
//           </DialogContentText>
//         </DialogContent>
//       </Dialog>
//     </Container>
//   );
// };

// export default RentDetails;


import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, addProperty, incrementPropertyCount } from '../Commonlibs/userSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  TextField,
  Grid,
  InputAdornment,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import {
  Check as CheckIcon,
  Phone,
  Email,
  Person,
} from "@mui/icons-material";
import Loader from '../Loader/Loader';
import PostAccess from './PostAccess';

const RentDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  // State variables for form data
  const [monthlyRent, setMonthlyRent] = useState(() => localStorage.getItem('rent_monthlyRent') || '');
  const [monthlyRentError, setMonthlyRentError] = useState('');
  const [currency, setCurrency] = useState(() => localStorage.getItem('rent_currency') || '₹');
  const [availableFrom, setAvailableFrom] = useState(() => localStorage.getItem('rent_availableFrom') || '');
  const [availableFromError, setAvailableFromError] = useState('');
  const [securityDeposit, setSecurityDeposit] = useState(() => localStorage.getItem('rent_securityDeposit') || 'none');
  const [constructionStatus, setConstructionStatus] = useState('ready to move');

  // State for loading and alerts
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

  // Profile verification states (NO OTP)
  const [profileData, setProfileData] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [showVerificationDialog, setShowVerificationDialog] = useState(false);
  const [verificationForm, setVerificationForm] = useState({
    fullName: '',
    email: '',
    contactNumber: '',
  });
  const [verificationErrors, setVerificationErrors] = useState({});
  const [verificationLoading, setVerificationLoading] = useState(false);

  // Get data from previous screens
  const { propertyType, category, ...otherProps } = location.state || {};

  // Clear all form data function
  const clearAllRentFormData = () => {
    setMonthlyRent('');
    setCurrency('₹');
    setAvailableFrom('');
    setSecurityDeposit('none');
    setConstructionStatus('ready to move');
    localStorage.removeItem('rent_monthlyRent');
    localStorage.removeItem('rent_currency');
    localStorage.removeItem('rent_availableFrom');
    localStorage.removeItem('rent_securityDeposit');
    localStorage.removeItem('propertyDetailsFormState');
    localStorage.removeItem('propertyType');
    localStorage.removeItem('category');
    localStorage.removeItem('propertyLocation');
     localStorage.removeItem('amenities_society');
  localStorage.removeItem('amenities_furnishing');
  localStorage.removeItem('amenities_other');
  localStorage.removeItem('propertyImagePreviews');
    setMonthlyRentError('');
    setAvailableFromError('');
  };

  // Fetch user profile data on mount
  useEffect(() => {
    const fetchUserProfile = async () => {
      const userId = user?.id;
      if (!userId) {
        setLoadingProfile(false);
        return;
      }
      try {
        setLoadingProfile(true);
        const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
        const data = await response.json();
        if (data.status === "SUCCESS") {
          setProfileData(data.result);
        }
      } catch (err) {
        console.error('Error fetching profile:', err);
      } finally {
        setLoadingProfile(false);
      }
    };
    fetchUserProfile();
  }, [user?.id]);

const handleBack = () => {
  const assetType = location.state?.asset_type || '';
  const selectedType = location.state?.selectedType || '';
  const isPlot = assetType === 'plot' || selectedType === 'plot';
  const isAgricultureLand = assetType?.toLowerCase() === 'agriculture land' || selectedType === 'agriculture-land';
  const isCommercial = propertyType === 'Commercial';

  // ✅ Determine if amenities should be shown
  const shouldShowAmenities = !isCommercial && !isPlot && !isAgricultureLand;

  if (shouldShowAmenities) {
    // Navigate back to Amenities
    navigate('/amenities', {
      state: {
        propertyType: propertyType || location.state?.propertyType,
        category: category || location.state?.category,
        location: location.state?.location || '',
        asset_type: location.state?.asset_type || '',
        selectedType: location.state?.selectedType || '',
        ...location.state
      }
    });
  } else {
    // Skip Amenities, go directly to Property Details
    navigate('/property-details', {
      state: {
        propertyType: propertyType || location.state?.propertyType,
        category: category || location.state?.category,
        location: location.state?.location || '',
        asset_type: location.state?.asset_type || '',
        selectedType: location.state?.selectedType || '',
        ...location.state
      }
    });
  }
};

  // Helper function to format number with Indian comma system
  const formatIndianNumber = (num) => {
    if (!num) return '';
    const numStr = num.toString();
    const lastThree = numStr.substring(numStr.length - 3);
    const otherNumbers = numStr.substring(0, numStr.length - 3);
    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }
    return lastThree;
  };

  // Helper function to convert number to words (Indian system)
  const convertToWords = (num) => {
    if (!num || num === '0') return '';
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numToWords = (n) => {
      if (n < 10) return ones[n];
      if (n < 20) return teens[n - 10];
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
      return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + numToWords(n % 100) : '');
    };

    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num % 10000000) / 100000);
    const thousand = Math.floor((num % 100000) / 1000);
    const hundred = num % 1000;

    let result = '';
    if (crore > 0) result += numToWords(crore) + ' Crore ';
    if (lakh > 0) result += numToWords(lakh) + ' Lakh ';
    if (thousand > 0) result += numToWords(thousand) + ' Thousand ';
    if (hundred > 0) result += numToWords(hundred);

    return result.trim();
  };

  // Validate monthly rent
  const validateMonthlyRent = (value) => {
    if (!value || value.trim() === '') {
      setMonthlyRentError('Monthly rent is required');
      return false;
    }
    const amountRegex = /^\d+(\.\d{0,2})?$/;
    if (!amountRegex.test(value)) {
      setMonthlyRentError('Please enter a valid amount (e.g., 5000 or 5000.50)');
      return false;
    }
    const amount = parseFloat(value);
    if (amount < 100) {
      setMonthlyRentError('Monthly rent must be at least 100');
      return false;
    }
    if (amount > 100000000) {
      setMonthlyRentError('Monthly rent cannot exceed 10 crores');
      return false;
    }
    setMonthlyRentError('');
    return true;
  };

  // Validate available from date
  const validateAvailableFrom = (value) => {
    if (!value || value.trim() === '') {
      setAvailableFromError('Available from date is required');
      return false;
    }
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(value)) {
      setAvailableFromError('Invalid date format');
      return false;
    }
    const selectedDate = new Date(value);
    if (isNaN(selectedDate.getTime())) {
      setAvailableFromError('Invalid date');
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (selectedDate < today) {
      setAvailableFromError('Date must be today or in the future');
      return false;
    }
    const twoYearsFromNow = new Date();
    twoYearsFromNow.setFullYear(today.getFullYear() + 2);
    if (selectedDate > twoYearsFromNow) {
      setAvailableFromError('Date cannot be more than 2 years in the future');
      return false;
    }
    setAvailableFromError('');
    return true;
  };

  // Handle monthly rent change
  const handleMonthlyRentChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
      setMonthlyRent(value);
      validateMonthlyRent(value);
    }
  };

  // Handle available from change
  const handleAvailableFromChange = (e) => {
    const value = e.target.value;
    setAvailableFrom(value);
    validateAvailableFrom(value);
  };

  // Validation functions for verification form
  const validateVerificationField = (name, value) => {
    if (!value || value.trim() === '' || value === 'N/A') {
      return `${name} is required`;
    }
    switch (name) {
      case 'fullName':
        return /^[A-Za-z\s]{2,50}$/.test(value)
          ? ''
          : 'Name should contain only letters and spaces (2-50 characters)';
      case 'email':
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ''
          : 'Please enter a valid email address';
      case 'contactNumber':
        return /^\d{10}$/.test(value)
          ? ''
          : 'Phone number should be 10 digits';
      default:
        return '';
    }
  };

  // Handle verification form changes
  const handleVerificationChange = (field, value) => {
    setVerificationForm(prev => ({ ...prev, [field]: value }));
    if (verificationErrors[field]) {
      setVerificationErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Handle phone number input (only digits)
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
      handleVerificationChange('contactNumber', value);
    }
  };

  // Update user profile (NO OTP - Direct Update)
  const updateUserProfile = async () => {
    setVerificationLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('user_id', user?.id);
      formDataToSend.append('full_name', verificationForm.fullName);
      formDataToSend.append('email_id', verificationForm.email);
      formDataToSend.append('contact_number', verificationForm.contactNumber);

      const response = await fetch('https://propertydealstalk.com/api/users/UpdateUserprofile', {
        method: 'POST',
        body: formDataToSend,
      });

      const data = await response.json();

      if (data.status === "SUCCESS") {
        setProfileData(data.result);
        setShowVerificationDialog(false);
        setTimeout(() => {
          performPropertyUpload();
        }, 500);
      } else {
        setAlert({
          open: true,
          message: data.message || 'Failed to update profile',
          severity: 'error'
        });
      }
    } catch (error) {
      console.error('Profile update error:', error);
      setAlert({
        open: true,
        message: 'Failed to update profile. Please try again.',
        severity: 'error'
      });
    } finally {
      setVerificationLoading(false);
    }
  };

  // Handle verification submit (Direct - No OTP)
  const handleVerificationSubmit = async () => {
    const newErrors = {};
    Object.keys(verificationForm).forEach(key => {
      const error = validateVerificationField(key, verificationForm[key]);
      if (error) newErrors[key] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      setVerificationErrors(newErrors);
      return;
    }

    await updateUserProfile();
  };

  // Handle property upload - check profile first
  const handleUploadProperty = async () => {
    const isRentValid = validateMonthlyRent(monthlyRent);
    const isDateValid = validateAvailableFrom(availableFrom);

    if (!isRentValid || !isDateValid) {
      setAlert({
        open: true,
        message: 'Please fix the errors before submitting',
        severity: 'error'
      });
      return;
    }

    // Check if user profile needs verification
    const needsVerification =
      !profileData?.full_name ||
      profileData.full_name === 'N/A' ||
      !profileData?.email_id ||
      profileData.email_id === 'N/A' ||
      !profileData?.contact_number ||
      profileData.contact_number === 'N/A';

    if (needsVerification) {
      setVerificationForm({
        fullName: profileData?.full_name && profileData.full_name !== 'N/A' ? profileData.full_name : '',
        email: profileData?.email_id && profileData.email_id !== 'N/A' ? profileData.email_id : '',
        contactNumber: profileData?.contact_number && profileData.contact_number !== 'N/A' ? profileData.contact_number : '',
      });
      setShowVerificationDialog(true);
      return;
    }

    await performPropertyUpload();
  };

  // Actual property upload logic
  const performPropertyUpload = async () => {
    setLoading(true);

    try {
      if (!monthlyRent || !availableFrom || !securityDeposit) {
        setAlert({
          open: true,
          message: 'Please fill all required fields',
          severity: 'error'
        });
        setLoading(false);
        return;
      }

      const userId = user?.id;
      if (!userId) {
        throw new Error('User not authenticated');
      }

      const assetType = location.state?.asset_type || '';
      const selectedType = location.state?.selectedType || '';
      const isplot = assetType === 'plot' || selectedType === 'plot';
      const isAgricultureLand = assetType.toLowerCase() === 'agriculture land' || selectedType === 'agriculture-land';
      const isCommercial = propertyType === 'Commercial';

      const formData = new FormData();
      formData.append('seller_id', userId);
      formData.append('property_type', isCommercial ? 'commercial' : 'residential');
      formData.append('category', 'rent');
      formData.append('location', location.state?.location || '');
      formData.append('asset_type', assetType);
      formData.append('property_name', location.state?.buildingName || '');
      formData.append('area_name', location.state?.areaName || '');
      formData.append('full_address', location.state?.completeAddress || location.state?.full_address || '');

      const showAreaFields = assetType.toLowerCase() === 'apartment' || selectedType === 'apartment' ||
        assetType.toLowerCase() === 'independent house' || selectedType === 'independent-house' ||
        assetType.toLowerCase() === 'duplex' || selectedType === 'duplex';

      formData.append('carpet_area', showAreaFields ? (location.state?.carpet_area || '') : '');
      formData.append('carpet_area_units', showAreaFields ? (location.state?.carpet_area_units || '') : '');
      formData.append('built_up_area', showAreaFields ? (location.state?.built_up_area || '') : '');
      formData.append('built_up_area_units', showAreaFields ? (location.state?.built_up_area_units || '') : '');
      formData.append('uds', showAreaFields ? (location.state?.uds_area || '') : '');
      formData.append('uds_units', showAreaFields ? (location.state?.uds_area_units || 'Sq.Ft') : '');

      const youtubeLink = location.state?.youtubeLink?.trim();
      formData.append('youtube_link', youtubeLink || null);

      formData.append('property_size', location.state?.propertySize || '');
      formData.append('property_size_units', location.state?.property_size_units || location.state?.selectedUnit || '');
      formData.append('length', location.state?.length || location.state?.propertyLength || '');
      formData.append('width', location.state?.width || location.state?.propertyWidth || '');
      formData.append('construction_status', constructionStatus || 'ready to move');

      // Price fields for rent
      formData.append('monthly_rent', Number(monthlyRent) || 0);
      formData.append('available_from', availableFrom);
      formData.append('security_deposit', securityDeposit);
      formData.append('currency', currency);

      // Set sale-specific fields to null
      formData.append('asking_price', null);
      formData.append('negotiable', null);

      formData.append('age_of_property', location.state?.age_of_property || '5');

      // SPECIAL HANDLING FOR PLOT AND AGRICULTURE LAND
      if (isplot || isAgricultureLand) {
        formData.append('locality', null);
        formData.append('bhk', null);
        formData.append('furnish_type', null);
        formData.append('total_floors', null);
        formData.append('select_floor', null);
        formData.append('society_aminities', null);
        formData.append('furnish_facilities', null);
        formData.append('other_facilities', null);
        formData.append('facilities_distance', null);

        if (isplot) {
          const description = location.state?.propertyDescription || location.state?.description || '';
          const content = location.state?.propertyContent || location.state?.content || '';
          formData.append('description', description || null);
          formData.append('content', content || null);
        } else {
          formData.append('description', null);
          formData.append('content', null);
        }

        if (isCommercial) {
          formData.append('commercial_catgory', 'rent');
          formData.append('commercial_asset_type', assetType);
          formData.append('hub', null);
          formData.append('ownership', null);
        } else {
          formData.append('commercial_catgory', null);
          formData.append('commercial_asset_type', null);
          formData.append('hub', null);
          formData.append('ownership', null);
        }
      } else {
        // REGULAR PROPERTIES (Apartment, House, Office, etc.)
        formData.append('locality', location.state?.locality || null);

        if (!isCommercial) {
          formData.append('bhk', location.state?.bhk || location.state?.selectedBHK || '');
          formData.append('furnish_type', location.state?.furnish_type || location.state?.selectedFurnish || '');
        } else {
          formData.append('bhk', null);
          formData.append('furnish_type', null);
        }

        formData.append('total_floors', location.state?.totalFloors || location.state?.total_floors || '');
        formData.append('select_floor', location.state?.selectedFloor || location.state?.select_floor || '');

        if (!isCommercial && location.state) {
          const societyAmenities = location.state.society_aminities || '';
          const furnishFacilities = location.state.furnish_facilities || '';
          const otherFacilities = location.state.other_facilities || '';

          formData.append('society_aminities', societyAmenities || null);
          formData.append('furnish_facilities', furnishFacilities || null);
          formData.append('other_facilities', otherFacilities || null);
          formData.append('facilities_distance', location.state?.facilities_distance || '1km');
        } else {
          formData.append('society_aminities', null);
          formData.append('furnish_facilities', null);
          formData.append('other_facilities', null);
          formData.append('facilities_distance', null);
        }

        if (isCommercial) {
          formData.append('commercial_catgory', 'rent');
          formData.append('commercial_asset_type', assetType);
          formData.append('hub', location.state?.hub || location.state?.selectedHub || '');
          formData.append('ownership', location.state?.ownership || location.state?.selectedOwnership || 'Freehold');
        } else {
          formData.append('commercial_catgory', null);
          formData.append('commercial_asset_type', null);
          formData.append('hub', null);
          formData.append('ownership', null);
        }
      }

      // Add images to the FormData
      if (location.state?.propertyImages && location.state.propertyImages.length > 0) {
        location.state.propertyImages.forEach((file) => {
          formData.append('property_images', file);
        });
      }

      // Add videos to the FormData
      if (location.state?.propertyVideos && location.state.propertyVideos.length > 0) {
        location.state.propertyVideos.forEach((file) => {
          formData.append('property_videos', file);
        });
      }

      // API call with FormData
      const response = await fetch('https://propertydealstalk.com/api/property/addProperty', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.status === 'SUCCESS') {
        clearAllRentFormData();

        // Store property ID in Redux if available
        if (data.result && data.result.id) {
          dispatch(addProperty(data.result.id));
          dispatch(incrementPropertyCount());
        }

        setAlert({
          open: true,
          message: 'Property added successfully!',
          severity: 'success'
        });

        setTimeout(() => {
          navigate('/sell-properties');
        }, 2000);
      } else {
        throw new Error(data.message || 'Failed to add property');
      }
    } catch (error) {
      console.error('Error adding property:', error);
      clearAllRentFormData();
      setAlert({
        open: true,
        message: error.message || 'Failed to add property. Please try again.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  // Persist form values to localStorage
  useEffect(() => {
    localStorage.setItem('rent_monthlyRent', monthlyRent);
    localStorage.setItem('rent_currency', currency);
    localStorage.setItem('rent_availableFrom', availableFrom);
    localStorage.setItem('rent_securityDeposit', securityDeposit);
  }, [monthlyRent, currency, availableFrom, securityDeposit]);

  // Auto-hide popup after a delay
  useEffect(() => {
    if (alert.open) {
      const timer = setTimeout(() => {
        setAlert({ ...alert, open: false });
      }, 9000);
      return () => clearTimeout(timer);
    }
  }, [alert.open]);

  return (
    <PostAccess
      currentStep={3}
      category={category}
      propertyType={propertyType}
      assetType={location.state?.asset_type || ''}
    >
      {loading && <Loader />}

      <Box
        sx={{
          flex: 1,
          maxWidth: { xs: '100%', md: '800px' },
          p: { xs: 2.5, sm: 3, md: 3.5 },
          backgroundColor: '#ffffff',
          borderRadius: 2,
          border: '1px solid #e0e0e0',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 600,
            mb: 0.5,
            fontSize: { xs: '18px', md: '22px' },
          }}
        >
          Add Rent Details
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Outfit',
            fontSize: '13px',
            color: '#666',
            mb: 3,
          }}
        >
          Complete all required fields
        </Typography>

        {/* Form Content */}
        <Box sx={{ mt: 4 }}>
          {/* All Three Fields in Single Line with 270px width each */}
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 4 }}>
            {/* Monthly Rent */}
            <Box sx={{ width: '220px' }}>
              <Typography
                component="label"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "16px",
                  display: "block",
                  mb: 1.5,
                }}
              >
                Monthly Rent <Box component="span" sx={{ color: "#ff0000" }}>*</Box>
              </Typography>
              <TextField
                placeholder="Enter amount"
                value={formatIndianNumber(monthlyRent)}
                onChange={(e) => {
                  const value = e.target.value.replace(/,/g, '');
                  if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                    setMonthlyRent(value);
                    validateMonthlyRent(value);
                  }
                }}
                error={!!monthlyRentError}
                helperText={monthlyRentError}
                InputProps={{
                  endAdornment: <InputAdornment position="end">₹</InputAdornment>,
                }}
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": {
                    height: "50px",
                    bgcolor: "background.paper",
                    borderRadius: "10px",
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "15px",
                  },
                }}
              />
              {monthlyRent && !monthlyRentError && (
                <Typography
                  sx={{
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "12px",
                    color: "#4f26ff",
                    mt: 0.5,
                    fontStyle: "italic",
                  }}
                >
                  {convertToWords(parseInt(monthlyRent.split('.')[0], 10))}
                </Typography>
              )}
            </Box>

            {/* Available From */}
            <Box sx={{ width: '220px' }}>
              <Typography
                component="label"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "16px",
                  display: "block",
                  mb: 1.5,
                }}
              >
                Available from <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
              </Typography>
              <TextField
                placeholder="Select Date"
                type="date"
                value={availableFrom}
                onChange={handleAvailableFromChange}
                error={!!availableFromError}
                helperText={availableFromError}
                inputProps={{
                  min: new Date().toISOString().split('T')[0],
                }}
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": {
                    height: "50px",
                    borderRadius: "10px",
                    fontSize: "15px",
                    fontFamily: "Outfit, sans-serif"
                  }
                }}
              />
            </Box>

            {/* Security Deposit Dropdown */}
            <Box sx={{ width: '220px' }}>
              <Typography
                component="label"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "16px",
                  display: "block",
                  mb: 1.5,
                }}
              >
                Security Deposit <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={securityDeposit}
                  onChange={(e) => setSecurityDeposit(e.target.value)}
                  sx={{
                    height: "50px",
                    borderRadius: "10px",
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "15px",
                    bgcolor: "white",
                  }}
                >
                  <MenuItem value="none" sx={{ fontFamily: "Outfit, sans-serif" }}>
                    None
                  </MenuItem>
                  <MenuItem value="1month" sx={{ fontFamily: "Outfit, sans-serif" }}>
                    1 Month
                  </MenuItem>
                  <MenuItem value="2month" sx={{ fontFamily: "Outfit, sans-serif" }}>
                    2 Month
                  </MenuItem>
                  <MenuItem value="custom" sx={{ fontFamily: "Outfit, sans-serif" }}>
                    Custom
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Box>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 6,
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              px: 3,
              py: 1.2,
              borderRadius: 1.5,
              textTransform: "none",
              fontFamily: "Outfit",
              fontSize: "14px",
              color: "#666",
              borderColor: "#e0e0e0",
              minWidth: "100px",
            }}
          >
            Back
          </Button>

          <Button
            onClick={handleUploadProperty}
            disabled={loading || !!monthlyRentError || !!availableFromError}
            sx={{
              px: 3,
              py: 1.2,
              borderRadius: 1.5,
              textTransform: "none",
              fontFamily: "Outfit",
              fontSize: "14px",
              backgroundColor: "#1976d2",
              color: "white",
              minWidth: "150px",
              '&:hover': {
                backgroundColor: "#1565c0",
              },
              '&:disabled': {
                bgcolor: '#b0b0b0',
                color: '#f5f5f5'
              }
            }}
          >
            {loading ? "Uploading..." : "Post Property"}
          </Button>
        </Box>
      </Box>

      {/* Profile Verification Dialog (NO OTP) */}
      <Dialog
        open={showVerificationDialog}
        onClose={() => !verificationLoading && setShowVerificationDialog(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            p: 2,
          }
        }}
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          fontSize: '24px',
          pb: 1
        }}>
          Verify Your Details
        </DialogTitle>

        <DialogContent>
          <Typography sx={{
            fontFamily: 'Outfit',
            fontSize: '14px',
            color: '#666',
            mb: 3
          }}>
            Please verify your contact information before posting the property
          </Typography>

          {/* Full Name */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{
              fontFamily: 'Outfit',
              fontSize: '14px',
              fontWeight: 500,
              mb: 1
            }}>
              Full Name <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter your full name"
              value={verificationForm.fullName}
              onChange={(e) => handleVerificationChange('fullName', e.target.value)}
              error={!!verificationErrors.fullName}
              helperText={verificationErrors.fullName}
              disabled={verificationLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person sx={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  fontFamily: 'Outfit',
                }
              }}
            />
          </Box>

          {/* Email */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{
              fontFamily: 'Outfit',
              fontSize: '14px',
              fontWeight: 500,
              mb: 1
            }}>
              Email Address <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              type="email"
              placeholder="Enter your email"
              value={verificationForm.email}
              onChange={(e) => handleVerificationChange('email', e.target.value)}
              error={!!verificationErrors.email}
              helperText={verificationErrors.email}
              disabled={verificationLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email sx={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  fontFamily: 'Outfit',
                }
              }}
            />
          </Box>

          {/* Mobile Number */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{
              fontFamily: 'Outfit',
              fontSize: '14px',
              fontWeight: 500,
              mb: 1
            }}>
              Mobile Number <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter 10-digit mobile number"
              value={verificationForm.contactNumber}
              onChange={handlePhoneNumberChange}
              error={!!verificationErrors.contactNumber}
              helperText={verificationErrors.contactNumber}
              disabled={verificationLoading}
              inputProps={{ maxLength: 10 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone sx={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  fontFamily: 'Outfit',
                }
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={() => {
              if (!verificationLoading) {
                setShowVerificationDialog(false);
                setVerificationErrors({});
              }
            }}
            disabled={verificationLoading}
            sx={{
              textTransform: 'none',
              fontFamily: 'Outfit',
              color: '#666',
              borderRadius: '8px',
              px: 3,
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleVerificationSubmit}
            disabled={verificationLoading}
            variant="contained"
            sx={{
              textTransform: 'none',
              fontFamily: 'Outfit',
              bgcolor: '#4f26ff',
              borderRadius: '8px',
              px: 3,
              '&:hover': {
                bgcolor: '#3d1fd9',
              },
            }}
          >
            {verificationLoading ? (
              <CircularProgress size={24} sx={{ color: 'white' }} />
            ) : (
              'Confirm'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Alert Dialog */}
      <Dialog
        open={alert.open}
        onClose={() => setAlert({ ...alert, open: false })}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
            maxWidth: "400px",
            width: "100%",
            margin: '0 16px',
            overflow: 'hidden'
          }
        }}
      >
        <DialogContent sx={{
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#ffffff",
          minHeight: "180px",
        }}>
          {/* Icon based on alert severity */}
          <Box sx={{ mb: 2 }}>
            {alert.severity === 'success' && (
              <CheckIcon sx={{
                fontSize: 48,
                color: '#2e7d32',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(46, 125, 50, 0.1)'
              }} />
            )}
            {alert.severity === 'error' && (
              <Box component="span" sx={{
                fontSize: 48,
                color: '#d32f2f',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(211, 47, 47, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                ✕
              </Box>
            )}
            {alert.severity === 'warning' && (
              <Box component="span" sx={{
                fontSize: 48,
                color: '#ed6c02',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(237, 108, 2, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                !
              </Box>
            )}
            {alert.severity === 'info' && (
              <Box component="span" sx={{
                fontSize: 48,
                color: '#0288d1',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(2, 136, 209, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                i
              </Box>
            )}
          </Box>

          <DialogContentText sx={{
            fontFamily: "Outfit, sans-serif",
            fontSize: "18px",
            textAlign: "center",
            color: alert.severity === 'error' ? '#d32f2f' :
              alert.severity === 'warning' ? '#ed6c02' :
                alert.severity === 'success' ? '#2e7d32' : '#0288d1',
            margin: 0,
            fontWeight: 500
          }}>
            {alert.message}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </PostAccess>
  );
};

export default RentDetails;